import React from 'react';
import '../styles/Toast.css';

const Toast: React.FC<{ message: string }> = ({ message }) => {
  return (
    <div className="global-toast">
      {message}
    </div>
  );
};

export default Toast;